import script from "./AuthorEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthorEmail.vue?vue&type=script&setup=true&lang=js"

import "./AuthorEmail.vue?vue&type=style&index=0&id=3f9b21e6&lang=scss"

const __exports__ = script;

export default __exports__